import { useState } from 'react';
import { Header, Filter } from './types';

interface UseFilterBuilderParams {
  onApplyFilter: (filter: Filter) => void;
}

export const useFilterBuilder = ({ onApplyFilter }: UseFilterBuilderParams) => {
  const [selectedField, setSelectedField] = useState<Header | null>(null);
  const [selectedFilterType, setSelectedFilterType] = useState<string>('');
  const [filterValue, setFilterValue] = useState<string>('');
  const [displayValue, setDisplayValue] = useState<string>('');

  const handleSelectField = (field: Header) => {
    setSelectedField(field);
    setSelectedFilterType('');
    setFilterValue('');
    setDisplayValue('');
  };

  const handleSelectFilterType = (type: string) => {
    setSelectedFilterType(type);
  };

  const handleApply = () => {
    if (!selectedField || !selectedFilterType || (filterValue.trim() === '' && selectedField.type !== 'boolean')) {
      return;
    }

    const resolvedDisplayValue = selectedField.type === 'boolean'
      ? (selectedFilterType === 'true' ? 'Verdadeiro' : 'Falso')
      : (displayValue !== '' ? displayValue : filterValue);

    const newFilter: Filter = {
      key: selectedField.key,
      label: selectedField.label,
      filterType: selectedFilterType,
      value: selectedField.type === 'boolean' ? selectedFilterType === 'true' : filterValue,
      displayValue: resolvedDisplayValue,
      fieldType: selectedField.type,
    };

    onApplyFilter(newFilter);

    setSelectedField(null);
    setSelectedFilterType('');
    setFilterValue('');
    setDisplayValue('');
  };

  return {
    selectedField,
    selectedFilterType,
    filterValue,
    displayValue,
    setFilterValue,
    setDisplayValue,
    handleSelectField,
    handleSelectFilterType,
    handleApply,
  };
};